import styled from "@emotion/styled";
import { Icon } from "@smartsheet/ursa-icons";
export const CheckmarkStyled = styled(Icon)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
//# sourceMappingURL=CheckmarkStyled.js.map